import { FunctionComponent, useCallback } from 'react'
import Modal from '@/components/RebrandedModal'
import { useModalContext } from '@/components/RebrandedModal/contexts/ModalContext'
import { useRealtimeAttendanceContext } from '@/modules/RealtimeAttendance/contexts/RealtimeAttendanceContext'
import { useStyles } from './styles'
import { Text } from '@conexasaude/conexa-hero'

const CallRestartedModal: FunctionComponent<{
  hookSuccess()
}> = ({ hookSuccess }) => {
  const { closeModal } = useModalContext()
  const {
    realtimeAttendance: { call },
  } = useRealtimeAttendanceContext()
  const styles = useStyles()

  const handleSucess = useCallback(() => {
    closeModal()
    hookSuccess()
  }, [closeModal, hookSuccess])

  return (
    <Modal
      id="CALL_RESTARTED"
      primaryAction={handleSucess}
      primaryActionLabel="Voltar para chamada"
    >
      <Text css={styles.informativeText}>
        {call?.professionalName} está precisando entrar em contato com você.
      </Text>
    </Modal>
  )
}

export default CallRestartedModal
